export default function numberToDay(number) {
    const days = [null, 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    return days[number];
  }
  